import PropTypes from "prop-types";
import { Input, Select } from "../../../components/FormComponents";
import { TEMPLATE_CATEGORIES } from "../../../constants/themes";

export default function GeneralInfo({
	formData,
	setFormData,
	errors,
	setErrors,
	companies,
}) {
	return (
		<div className="bg-slate-900/40 p-4 rounded-xl border border-white/5 space-y-4">
			<Input
				label="Nome *"
				value={formData.name}
				onChange={(e) => {
					setFormData({ ...formData, name: e.target.value });
					if (errors.name) setErrors({ ...errors, name: null });
				}}
				placeholder="Nome do template"
				error={errors.name}
			/>

			<div className="grid grid-cols-2 gap-3">
				<Select
					label="Categoria *"
					value={formData.category}
					onChange={(e) =>
						setFormData({ ...formData, category: e.target.value })
					}
					options={TEMPLATE_CATEGORIES.map((c) => ({
						value: c.value,
						label: c.label,
					}))}
				/>
				<Select
					label="Empresa (opcional)"
					value={formData.company_id}
					onChange={(e) =>
						setFormData({ ...formData, company_id: e.target.value })
					}
					options={companies.map((c) => ({ value: c.id, label: c.name }))}
					placeholder="Todas as empresas"
				/>
			</div>
		</div>
	);
}

GeneralInfo.propTypes = {
	formData: PropTypes.object.isRequired,
	setFormData: PropTypes.func.isRequired,
	errors: PropTypes.object.isRequired,
	setErrors: PropTypes.func.isRequired,
	companies: PropTypes.array.isRequired,
};
